import { render, staticRenderFns } from "./RiskmaAttributionLayer.vue?vue&type=template&id=1933f820&scoped=true&"
import script from "./RiskmaAttributionLayer.vue?vue&type=script&lang=js&"
export * from "./RiskmaAttributionLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933f820",
  null
  
)

/* custom blocks */
import block0 from "./RiskmaAttributionLayer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports